import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import shortid from 'shortid';
import AccordionItem from './AccordionItem';
import AccordionTitle from './AccordionTitle';
import AccordionBody from './AccordionBody';
import './Accordion.css';

const MODE = {
  single: 'single',
  multiple: 'multiple',
};

const getActives = (elements, mode, actives) => {
  elements.map((item, index) => {
    return item.props.children.map((ch) => {
      if (ch.props.active) {
        actives.push(index);
      }
      return actives;
    });
  });
  const activesElement =
    mode === MODE.single && actives.length > 0 ? actives.slice(0, 1) : actives;
  return activesElement;
};

class Accordion extends Component {
  constructor(props) {
    super(props);

    const { children, mode } = this.props;
    const elements = Array.isArray(children) ? children : [children];
    const { selectedItemsIndex = getActives(elements, mode, []) } = this.props;

    this.state = {
      selectedItemsIndex,
    };
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.selectedItemsIndex.length &&
      newProps.selectedItemsIndex !== this.props.selectedItemsIndex
    ) {
      if (this.props.mode === MODE.single) {
        if (newProps.selectedItemsIndex.length === 1) {
          this.setState({ selectedItemsIndex: newProps.selectedItemsIndex });
        }
      } else if (newProps.mode === this.props.mode) {
        this.setState({ selectedItemsIndex: newProps.selectedItemsIndex });
      } else {
        this.setState({
          selectedItemsIndex: [],
        });
      }
    }
    if (
      !newProps.selectedItemsIndex.length ||
      newProps.mode !== this.props.mode
    ) {
      let selectedItems = [];
      if (newProps.selectedItemsIndex && newProps.selectedItemsIndex.length) {
        selectedItems =
          newProps.mode === MODE.single
            ? newProps.selectedItemsIndex.slice(0, 1)
            : newProps.selectedItemsIndex;
      } else {
        const childs = Array.isArray(newProps.children)
          ? newProps.children
          : [newProps.children];
        selectedItems = getActives(childs, newProps.mode, []);
      }
      this.setState({
        selectedItemsIndex: selectedItems,
      });
    }
  }

  handleOnClick(evt, selectedItemIndex, onChange) {
    const { mode } = this.props;
    const currState = this.state.selectedItemsIndex;
    const itemIndex = currState.indexOf(selectedItemIndex);
    if (mode === MODE.single) {
      if (currState.length > 0) {
        currState.splice(0, currState.length);
      }
      if (itemIndex === -1) {
        currState.push(selectedItemIndex);
      }
    } else if (mode === MODE.multiple) {
      if (itemIndex !== -1) {
        currState.splice(itemIndex, 1);
      } else {
        currState.push(selectedItemIndex);
      }
    }
    this.setState({
      selectedItemsIndex: currState,
    });
    if (onChange) {
      onChange(selectedItemIndex, evt);
    }
  }

  processAccordionItems(onChange) {
    const { children } = this.props;
    const stateSelectedItemsIndex = this.state.selectedItemsIndex;
    const titleId = `accordion-title-${shortid.generate()}`;
    const bodyId = `accordion-body-${shortid.generate()}`;
    return React.Children.map(children, (item, index) => {
      const isActive =
        stateSelectedItemsIndex &&
        stateSelectedItemsIndex.indexOf(index) !== -1;
      // Check both the direct displayName and the type's displayName for compatibility with wrapped components
      if (
        item.type.displayName === 'Accordion.AccordionItem' ||
        item.type.displayName === AccordionItem.displayName
      ) {
        const newChildren = React.Children.map(item.props.children, (child) => {
          // Check both the direct displayName and the type's displayName for compatibility with wrapped components
          if (
            child.type.displayName === 'Accordion.AccordionTitle' ||
            child.type.displayName === AccordionTitle.displayName
          ) {
            return React.cloneElement(child, {
              id: titleId,
              controlsBody: bodyId,
              active: isActive,
              onClick: (e) => {
                this.handleOnClick(e, index, onChange);
              },
            });
          } else if (
            child.type.displayName === 'Accordion.AccordionBody' ||
            child.type.displayName === AccordionBody.displayName
          ) {
            return React.cloneElement(child, {
              id: bodyId,
              active: isActive,
            });
          }
          return null;
        });
        return React.cloneElement(item, {
          children: newChildren,
        });
      }
      return null;
    });
  }

  renderAccordionTitle() {
    const { title } = this.props;
    if (title !== '') {
      return <span>{title}</span>;
    }
    return null;
  }

  render() {
    const {
      className,
      onChange,
      selectedItemsIndex,
      title,
      ...otherProps
    } = this.props;
    const cn = classNames('ng-ui-widgets', 'ng-ui-accordion', className);
    const children = this.processAccordionItems(onChange);
    return (
      <div className={cn}>
        {this.renderAccordionTitle()}
        <ul {...otherProps}>{children}</ul>
      </div>
    );
  }
}

Accordion.defaultProps = {
  onChange: () => {},
  className: '',
  selectedItemsIndex: [],
  title: '',
  mode: MODE.multiple,
};

Accordion.propTypes = {
  mode: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(AccordionItem),
    PropTypes.objectOf(AccordionItem),
  ]).isRequired,
  onChange: PropTypes.func,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  title: PropTypes.string,
  selectedItemsIndex: PropTypes.arrayOf(PropTypes.number),
};

Accordion.AccordionItem = AccordionItem;
Accordion.AccordionBody = AccordionBody;
Accordion.AccordionTitle = AccordionTitle;
Accordion.MODE = MODE;

export default Accordion;
